export class DuplicateFardeInfos {
  duplicateChemises: boolean;
  description: string;
}
